import { Box, Button, Stack, Typography } from '@mui/material'
import { Wordmark } from '@/components'

/**
 * The screen after «Cerrar sesión».
 *
 * ── A NEW COMPONENT, NOT A VARIANT OF `NoAccessScreen` ──────────────────────
 * They answer different questions and only one of them has to leak nothing.
 * `NoAccessScreen` is shown to a visitor who must not learn that this surface
 * exists, and `staffGuard.test.tsx` pins that contract: zero props, no anchor,
 * and none of the words that would describe the tool. This screen is shown to
 * somebody who was just inside it and left on purpose, so it can say so — and
 * keeping them separate is what leaves those pins untouched.
 */
export function SignedOutScreen({ onSignIn }: { onSignIn: () => void }) {
  return (
    <Box
      sx={{
        minHeight: '100dvh',
        display: 'grid',
        placeItems: 'center',
        bgcolor: 'background.default',
        p: 3,
      }}
    >
      <Stack spacing={2.5} sx={{ alignItems: 'center', textAlign: 'center', maxWidth: 360 }}>
        <Wordmark size="lg" />
        <Typography variant="body2" color="text.secondary">
          Se cerró la sesión en esta pestaña.
        </Typography>
        <Button variant="outlined" onClick={onSignIn}>
          Entrar de nuevo
        </Button>
      </Stack>
    </Box>
  )
}
